import { Component, OnInit } from '@angular/core';
import { PortalMessageService } from '../portal.message/portal.message.service';
import { View, OrderByDirection } from '../../common/model/view';
import { MessageModel } from '../portal.message/model/message.model';
import { FaqMessageService } from '../faq.message/faq.message.service';

@Component({
  selector: 'app-faq-modal',
  templateUrl: './faq.modal.pug',
  styleUrls: ['./faq.modal.sass']
})
export class FaqModalComponent implements OnInit {

  private faqs: MessageModel[];
  private selectedFaq: string;

  constructor(
    public faqMessageService: FaqMessageService
  ) {
  }

  ngOnInit(): void {
    const view = new View();
    view.addOrUpdateFilter('Deleted', false);
    view.addOrUpdateFilter('Visible', 'true');
    view.addOrderBy('visibleFrom', OrderByDirection.Desc);
    view.Limit = 100;

    this.faqMessageService.getMessages(view).then((Faqs) => {
      if (Faqs.value.length > 0) {
        this.faqs = Faqs.value;

        if (this.faqs[0]) {
          this.selectedFaq = this.faqs[0].content;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/faq.modal/faq.component.ts